import { ResourceItemHtmlProvider } from "./resource-item-html-provider.js";

export class ResourceItemHtmlProviderChefPartners extends ResourceItemHtmlProvider {
  constructor(filterServices) {
    super(filterServices); 
  }

  getItemHtml(item, relatedMedia) {
    const { imageData, fileData } = super.setRelatedMedia(item, relatedMedia);   
    const imageFallback = 'https://d1l5pp53ux74mz.cloudfront.net/images/default-source/resources/partner_illustration-.svg';

    const html = `
        <div class="col-4">
            <div class="Card -h-scale">
                <div>
                    <div class="-w16 -mb3" style="min-height:100px;">
                      <img src="${!imageData.Url ? imageFallback : imageData.Url}" class="-h8" style="max-height:100px !important; width:auto !important;" alt="Partner Thumbnail" />
                    </div>
                    <h4 class="-mb2">${this.encodeHtml(item.Title)}</h4>
                    <p>${item.Description ? this.encodeHtml(item.Description) : ''}</p>
                    <a href="${item.ExternalUrl}" class="-mta -i-external" target="_blank">Visit Partner Site</a>
                </div>
            </div>
        </div>
    `;

    return html;

  }
}
